export const CUSTOMFORM_PARTICIPATION_SUPPORT_URL = 'https://share.hsforms.com/1tm8wUMVFRfik8r0dAG-OLwqtklc';
export const ITEM_PRICING_STRINGS = {
  PRICE: 'Price',
  STRIPE_TITLE: 'Stripe Payment Page',
  STRIPE_SUB_TITLE: 'Allow participants to checkout and pay directly online.',
  STANDARD_FORM_TITLE: 'Standard Interest Form',
  STANDARD_FORM_SUB_TITLE: 'Collect participant information with no online payment.',
  CUSTOM_FORM_TITLE: 'Custom Form',
  CUSTOM_FORM_SUB_TITLE: 'Collect custom details, uploads, and online payment.',
}
export const POST_PARTICIPATION_DETAIL_SUBHEADINGS = {
  'Yes': 'This event has multiple shifts.',
  'No': 'This event has one shift.',
} as const;

export enum ticketingToggle {
  setPrice= 'Set Price',
  freeTicket = 'Free Ticket',
  discountGroups = 'Discount Groups'
}